module.exports = __webpack_public_path__ + "static/media/6.eb5a74d9.jpg";